import Header from "../components/common/header";
import Footer from "../components/common/footer";

export default function VisionPage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#000",
      }}
    >
      <Header />

      <div
        style={{
          flex: 1,
          padding: "32px",
          color: "#fff",
          maxWidth: "1000px",
          margin: "0 auto",
          lineHeight: 1.6,
        }}
      >
        {/* ===== HERO ===== */}
        <h1 style={{ marginBottom: "12px", color: "#7C3AED" }}>
          Real-Time On-Chain Analytics & Execution Infrastructure
        </h1>

        <p style={{ color: "#aaa", fontSize: "16px" }}>
          We are building a high-performance, multi-chain platform where on-chain
          data, analytics, and execution operate together in real time.
        </p>

        {/* ===== WHAT IS LIVE TODAY ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>What is live today</h2>

        <p>
          The platform already runs a live, production-grade data pipeline.
          It continuously ingests mempool and block data across multiple EVM
          networks, processes transactions in real time, and converts raw
          blockchain activity into structured on-chain signals.
        </p>

        <ul>
          <li>Live multi-chain mempool ingestion</li>
          <li>Real-time transaction parsing and classification</li>
          <li>Continuous operation under sustained load</li>
          <li>Infrastructure-first system design</li>
        </ul>

        {/* ===== LIVE PREVIEW ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>Live infrastructure preview</h2>

        <p style={{ color: "#aaa" }}>
          Below is a live view of raw real-time signals generated by the system.
          This interface is used for stress testing, throughput validation, and
          infrastructure stability checks.
        </p>

        <div
          style={{
            marginTop: "24px",
            padding: "16px",
            border: "1px solid #222",
            borderRadius: "8px",
            background: "#050505",
          }}
        >
          <p
            style={{
              marginBottom: "12px",
              color: "#888",
              fontSize: "14px",
            }}
          >
            Live signal stream (infrastructure testing environment)
          </p>

          <a
            href="/feed"
            style={{
              display: "inline-block",
              padding: "12px 20px",
              background: "#0a0a0a",
              border: "1px solid #333",
              borderRadius: "6px",
              color: "#0f0",
              textDecoration: "none",
              fontFamily: "monospace",
            }}
          >
            View live signals →
          </a>
        </div>

        {/* ===== ARCHITECTURE ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>Architecture (high level)</h2>

        <p>
          At a high level, the system consists of several tightly coupled layers:
        </p>

        <ul>
          <li>On-chain data ingestion (mempool and blocks)</li>
          <li>Real-time processing and transaction classification</li>
          <li>Structured signal generation</li>
          <li>Execution and consumer interfaces</li>
        </ul>

        {/* ===== ROADMAP ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>What we are building next</h2>

        <ul>
          <li>Automated trading and arbitrage bots</li>
          <li>MEV-aware execution and protection logic</li>
          <li>Advanced analytics and professional dashboards</li>
          <li>Execution-first DeFi primitives</li>
          <li>Tightly integrated DEX layer (later stage)</li>
        </ul>

        {/* ===== WHY IT MATTERS ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>Why this matters</h2>

        <p>
          Most on-chain platforms rely on delayed or abstracted data.
          Our approach is built around real-time market behavior,
          latency-sensitive execution, and infrastructure that can directly
          power trading and arbitrage logic.
        </p>

        {/* ===== INVESTMENT CONTEXT ===== */}
        <h2 style={{ marginTop: "48px", color: "#7C3AED" }}>Investment context</h2>

        <p>
          We are currently exploring crowdfunding and strategic investment to
          scale infrastructure, expand the product layer, and prepare for a
          broader public launch.
        </p>
      </div>

      <Footer />
    </div>
  );
}